import { Component, input, output, inject, signal, effect, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { Paginator } from "@shared/components/paginator/paginator";
import { PaginatorState } from 'primeng/paginator';
import { EmissionsFactory, EmissionsSourcesFactory } from '@features/emissions/models/emissions-factory.model';
import { SortHeader } from "@shared/components/sort-header/sort-header";
import { TableCheckbox } from 'primeng/table';
import { AuthService } from '@core/auth/services/auth-service';
import { UserDetailModel } from '@features/user/models/user.model';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';

type SourcesMapGroup = Record<string, string>;
type SourcesMap = {
  categories: SourcesMapGroup;
  sources: SourcesMapGroup;
  references: SourcesMapGroup;
  types: SourcesMapGroup;
  method: SourcesMapGroup;
  variations: SourcesMapGroup;
};

@Component({
  selector: 'app-emissions-sources-list',
  imports: [
    CommonModule,
    TableModule,
    Paginator,
    SortHeader,
    CheckboxModule,
    FormsModule
  ],
  templateUrl: './emissions-sources-list.component.html',
  styleUrls: ['./emissions-sources-list.component.scss']
})
export class EmissionsSourcesList implements OnInit {
  private readonly authService = inject(AuthService);

  userData: UserDetailModel | null = null;
  isAdmin: boolean = false;

  @Input() isBusinessSelection = false;
  @Input() isOfficeSelection = false;
  first = input<number>();
  rows = input<number>();
  @Input() data: EmissionsSourcesFactory[] = [];

  sourcesMap = input<SourcesMap>({
    categories: {},
    sources: {},
    references: {},
    types: {},
    method: {},
    variations: {}
  });

  typeSources = this.sourcesMap().types || {}

  totalRecords = input<number>(0);
  loading = input<boolean>(false);
  @Input() selectedSources: EmissionsSourcesFactory[] = [];

  @Output() selectionChange = new EventEmitter<EmissionsSourcesFactory[]>();


  @Input() selectedIds!: Set<string>;
  @Input() isAllSelected = false;
  @Input() isIndeterminate = false;

  @Output() toggleAll = new EventEmitter<boolean>();
  @Output() toggleRow = new EventEmitter<{ id: string; checked: boolean }>();

  onToggleAll(checked: boolean) {
    this.toggleAll.emit(checked);
  }

  onRowToggle(source: EmissionsSourcesFactory, checked: boolean) {
    this.toggleRow.emit({ id: source.Id, checked });
  }


  pageChange = output<PaginatorState>();

  sortBy = input<string | null>();
  sortOrder = input<string | null>();
  toggleSort = output<string>();

  ngOnInit(): void {
    this.userData = this.authService.getUser();
    this.isAdmin = this.userData?.Role === 'Admin';
  }

  hasData(): boolean {
    console.log(this.data, 'data')
    console.log(this.data.length > 0)
    return this.data.length > 0;
  }

  get selectedRows() {
    return this.data.filter((el) => el.IsAssigned);
  }

  get columnWidth(): string {
    return this.rows?.length ? '6rem' : '12rem';
  }



  private isInherited(item: EmissionsSourcesFactory): boolean {
    return (item as any).IsInherited === true;
  }

  isRowDisabled(item: EmissionsSourcesFactory): boolean {
    // Business: nada bloqueado
    if (this.isBusinessSelection) return false;

    // Office: bloquear heredados
    if (this.isOfficeSelection) return this.isInherited(item);

    // All/Group: todo bloqueado
    return true;
  }

  isHeaderDisabled(): boolean {
    if (this.isBusinessSelection) {
      return !this.data?.length;
    }

    if (this.isOfficeSelection) {
      return !this.data?.some(x => !this.isInherited(x));
    }

    return true;
  }

  getFactorName(code: string | null | undefined, group: keyof ReturnType<typeof this.sourcesMap>): string {

    const groupValue = this.sourcesMap()?.[group];
    if (!code) return '';



    if (typeof groupValue === 'object' && groupValue !== null) {
      return groupValue[code] ?? code;
    }

    return code; // fallback si no existe
  }

  handleToggleSort(columnName: string) {
    this.toggleSort.emit(columnName);
  }

  getGasValue(gases: { Name: string; Value: number | null }[], gasName: string): string {
    const gas = gases?.find(g => g.Name === gasName);
    return gas?.Value != null ? gas.Value.toFixed(3) : '(vacío)';
  }

  isWorldLocation(country: string): boolean {
    return country.toUpperCase() === 'WORLD' || country.toUpperCase() === 'WW';
  }

  onSelectionChange(event: any) {
    this.selectionChange.emit(event);
  }


}
